<template>
  <div>
    <div class="page-title-box">
      <div class="page-title-right">
        <permission name="UserCreate">
          <a href="javascript:void(0)" class="btn btn-primary" @click.prevent="showAddUserModal"
             id="show-add-user-modal">
            <i class="mdi mdi-account-multiple-plus mr-1"></i><span>Lisa kasutaja</span>
          </a>
        </permission>
      </div>

      <h4 class="page-title">Kasutajate haldus</h4>
    </div>

    <div class="card">
      <div class="card-body">
        <h4 class="header-title mt-0">Aktiivsed kasutajad</h4>
        <table class="table table-sm table-centered table-sticky table-hover mb-0">
          <thead>
          <tr>
            <th>Nimi</th>
            <th>Isikukood</th>
            <th>Objekt</th>
            <th>Email</th>
            <th>Telefon</th>
            <th></th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="user in activeUsers">
            <td>{{user.fullName}} (<strong>{{user.declarationReferencePrefix}}</strong>)</td>
            <td>{{user.personalCode}}</td>
            <td>{{user.object}}</td>
            <td>{{user.email}}</td>
            <td>{{user.phone}}</td>
            <td>
              <permission name="UserDeactivate">
                <button type="button" class="btn btn-link btn-sm float-right">
                  <i class="mdi mdi-delete" @click="deactivateUser(user.id)"></i>
                </button>
              </permission>
              <permission name="UserUpdate">
                <button type="button" class="btn btn-link btn-sm float-right">
                  <i class="mdi mdi-account-edit" @click="updateUser(user.id)"></i>
                </button>
              </permission>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div class="card mt-5">
      <div class="card-body">
        <h4 class="header-title mt-0">Mitteaktiivsed kasutajad</h4>
        <table class="table table-sm table-centered table-sticky table-hover mb-0">
          <thead>
          <tr>
            <th>Nimi</th>
            <th>Isikukood</th>
            <th>Objekt</th>
            <th>Email</th>
            <th>Telefon</th>
            <th></th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="user in notActiveUsers">
            <td>{{user.fullName}} (<strong>{{user.declarationReferencePrefix}}</strong>)</td>
            <td>{{user.personalCode}}</td>
            <td>{{user.object}}</td>
            <td>{{user.email}}</td>
            <td>{{user.phone}}</td>
            <td>
              <permission name="UserActivate">
                <button type="button" class="btn btn-link btn-sm float-right">
                  <i class="mdi mdi-recycle" @click="activateUser(user.id)"></i>
                </button>
              </permission>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>

    <modal ref="addUserModal" title="Lisa kasutaja" size="lg" @ok="loadUsers">
      <add-user slot-scope="{close, visible}" @done="close" v-if="visible"/>
    </modal>

    <modal ref="updateUserModal" title="Muuda kasutajat" size="lg" @ok="loadUsers">
      <update-user :user-id="data" slot-scope="{close, visible, data}" @done="close" v-if="visible"/>
    </modal>

  </div>
</template>

<script>
  import Modal from '@/components/Modal'
  import AddUser from '@/components/user/AddUser'
  import UpdateUser from '@/components/user/UpdateUser'

  export default {
    components: {Modal, AddUser, UpdateUser},
    data() {
      return {
        activeUsers: [],
        notActiveUsers: []
      }
    },
    methods: {
      loadUsers() {
        this.$gateway.get('/admin/users').then(response => {
          this.activeUsers = response.data.activeUsers
          this.notActiveUsers = response.data.notActiveUsers
        });
      },

      updateUser(userId) {
        this.$refs.updateUserModal.show(userId)
      },

      deactivateUser(userId) {
        this.$gateway.delete(`/admin/users/${userId}`).then(() => this.loadUsers());
      },

      activateUser(userId) {
        this.$gateway.patch(`/admin/users/${userId}`).then(() => this.loadUsers());
      },

      showAddUserModal() {
        this.$refs.addUserModal.show()
      }

    },
    created() {
      this.loadUsers();
    }
  }
</script>
